var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "document-form" },
    [
      _c("TabHeaderComponent", {
        attrs: { buttons: _vm.buttons, title: _vm.title },
        on: { saveForm: _vm.onSaveForm, closeForm: _vm.onCloseForm },
      }),
      _vm.tabs && _vm.tabs.length
        ? _c("TabsComponent", {
            ref: "tabComponent",
            staticClass: "tabs-secondary-styles",
            attrs: { tabs: _vm.tabs, context: _vm.context },
            on: { "changed-tab": _vm.tabChanged },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }